import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateTripDocumentPresignedUploadUrlInput,
  CreateTripDocumentPresignedUploadUrlResponse,
  MutationCreateTripDocumentPresignedUploadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateTripDocumentPresignedUploadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateTripDocumentPresignedUploadUrlInput]?: CreateTripDocumentPresignedUploadUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateTripDocumentPresignedUploadUrlResponse>;
}

// CreateTripDocumentPresignedUrl Service
export const { createTripDocumentPresignedUrl, useCreateTripDocumentPresignedUrl } = ((): {
  createTripDocumentPresignedUrl: ServiceMethod;
  useCreateTripDocumentPresignedUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateTripDocumentPresignedUploadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: CreateTripDocumentPresignedUploadUrlInput,
        options?: ConnectionOptions
      ): Promise<CreateTripDocumentPresignedUploadUrlResponse> => {
        const args: MutationCreateTripDocumentPresignedUploadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createTripDocumentPresignedUploadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createTripDocumentPresignedUploadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createTripDocumentPresignedUrl: fetch,
    useCreateTripDocumentPresignedUrl: useService,
  };
})();
